






























































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel,updateFile } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import { Public } from "@/http/api_Public";
import { fmoney } from "@/common/util/money";
import dayjs from "dayjs";
import axios from 'axios';
import XLSX from 'xlsx';
import store from '@/vuex/modules/login';
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
    updateFile,
  },
})
export default class storeApplet extends Vue {
  timeValue = [];
  /**登陆信息 */
  public userInfo =
    localStorage.getItem("dayChecked") == "true"
      ? JSON.parse(localStorage.getItem("userInfo"))
      : JSON.parse(sessionStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;
  totalStock=0;

  public $refs!: {
    form: HTMLFormElement;
  };
  // 搜索字段
  public searchValue = {
    shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    name: "",
    goodsClassId: "",
    supplierName:"",
    start: "",
    end: "",
    isShelves:true,
    timeSort: 0,
    skip: 0,
    count: 10,
  };
  /**列表选项 */
  selectTable = [];
  //所属分类的name名字总和
  departvalue = [];
  // 所属分类选择
  classOptions: any = [];
  exloading = false;
  // 合计
  totalnum = 0;
  totalprice = "0.00";

  statusOptions=[
      {
          label:"上架中",
          value:true,
      },
      {
          label:"已下架",
          value:false,
      },
  ]

  //文件相关
  public uploadShow: boolean = false;
  public uploadValue: any[] = [];
  public uploadList: any[] = [];
  /**规格库存明细 */
  ggList = [];
  dialogVisible = false;
  ggTotal = 0;

  async mounted() {
    await this.getlist();
    await this.gettotal();
    await this.getClassList();
    // handleEnter(this.handleSearch)
  }
  activated() {}
  // beforeDestroy(){
  //     window.removeEventListener('handleEnter',this.handleSearch,false) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
  // }

  /**商品分类 */
  async getClassList() {
    let res = await Public.GetAllGoodsClassList({});
    this.classOptions = res.map((v) => {
      return {
        ...v,
        children: v.items,
      };
    });
  }
  async handleChange(value) {
    if (value.length == 0) {
      const _cascader = this.$refs["cascaderHandle"];
      if (_cascader) {
        _cascader.$refs.panel.checkedValue = [];
        _cascader.$refs.panel.activePath = [];
        _cascader.$refs.panel.syncActivePath();
      }
    }
    if (value.length > 0) {
      console.log(value);
      if (value.length == 1) {
        this.searchValue.goodsClassId = value[0];
      } else {
        this.searchValue.goodsClassId = value[1];
      }
    } else {
      this.searchValue.goodsClassId = "";
    }
    this.$refs["cascaderHandle"].dropDownVisible = false;
  }
  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetTbGoodsList(this.searchValue);
    this.listData = result.items.map((v) => {
      return {
        ...v,
        salesTotal: v.salesTotal ? fmoney(v.salesTotal) : "0.00",
      };
    });
    this.total = result.totalCount;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  public async gettotal() {
    this.loading = true;
    let result = await Public.GetTbGoodsTotal(this.searchValue);
    this.totalStock = result.totalStock ? result.totalStock : 0;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  getSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    sums[0] = `合计 ${this.total} 条商品数据`;
    sums[5] = this.totalStock;
    return sums;
  }
  getDetailSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    sums[0] = "合计 负库存不纳入统计";
    sums[2] = this.ggTotal;
    return sums;
  }

  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    await this.gettotal();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.timeValue = [];
    this.searchValue = {
      shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
      name: "",
      goodsClassId: "",
      supplierName:"",
      start: "",
      end: "",
      isShelves:true,
      timeSort: 0,
      skip: 0,
      count: 10,
    };
    this.departvalue = [];
    const _cascader = this.$refs["cascaderHandle"];
    if (_cascader) {
      _cascader.$refs.panel.checkedValue = [];
      _cascader.$refs.panel.activePath = [];
      _cascader.$refs.panel.syncActivePath();
    }
    await this.getlist();
    await this.gettotal();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }
  //   /**查看详情 */
  //   viewRow(id) {
  //     this.$router.push(`./storeAppletDetail?id=${id}&name=detail`);
  //   }
  /**时间改变 */
  timeChange(val) {
    if (val) {
      this.searchValue.start = val[0] + " 00:00:00";
      this.searchValue.end = val[1] + " 23:59:59";
    } else {
      this.searchValue.start = "";
      this.searchValue.end = "";
    }
  }

  export_table(item) {
    try {
      this.exloading = true;
      Public.OrderItemReportExport(
        Object.assign({}, this.searchValue, {
          skip: 0,
          count: -1,
        })
      ).then((res) => {
        // let blob = new Blob([res]);
        // var objectUrl = URL.createObjectURL(blob);
        // var fileName = objectUrl.substring(objectUrl.lastIndexOf("/") + 1);
        var fileName = "商品销售报表";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
  }

  /**下载模板 */
  async downloadExcel(){
      const loading = this.$loading({
          lock: true,
          text: '下载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
      });
      let res = await Public.DownloadGoodsImportExcel();
      fileDownload(res.data, '商品模版' + ".xls");
      loading.close();
  }
  async submitHandler(){
        if(this.uploadValue.length==0)return;
        const loading = this.$loading({
            lock: true,
            text: '导入中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        let shopInfo = await Public.GetTbShopById({id:JSON.parse(localStorage.getItem("userInfo")).shopId});
        try{
          console.log('333',this.uploadValue,this.uploadValue[0].raw);
          let formData = new FormData();
          formData.append("file", this.uploadValue[0].raw);
          formData.append("shopId", JSON.parse(localStorage.getItem("userInfo")).shopId);
          formData.append("shopno", shopInfo.shopNo);
          axios
          .post("/api/ExInport/ImportGoods_RJDJ", formData, {
            responseType: "blob",
            headers: { 'Content-Type': 'application/xls','Authorization':`Bearer ${store.state.jwtToken}`},
          })
          .then(res => {
            console.log('res',res);
            if (res.data.type == "application/ms-excel") {
              console.log('测试');
              const a = document.createElement("a");
              a.download = "商品.xls";
              a.href = window.URL.createObjectURL(res.data);
              a.click();
              a.remove();
              const confirmText = ['存在未能成功导入的商品信息，表格已导出至本地。','小贴士:打开表格并检查商品信息是否填写有误，确定无误后重新导入。'];
              const newDatas = [];
              const h = this.$createElement;
              for (const i in confirmText) {
                  newDatas.push(h('p', null, confirmText[i]));
              }
              this.$confirm("",{
                    message: h('div', null, newDatas),
                    title:'提示',
                    confirmButtonText: '我知道了',
                    type: 'warning',
                    showCancelButton:false
                })
                .then(async () => {
                  this.onReset();
                })
                .catch(() => {
                  this.onReset();
                });
              this.uploadValue = [];
              loading.close();
            } else if (res.data.type == "application/json") {
              console.log('222');
              const that = this
              const reader = new FileReader(); //创建一个FileReader实例
              reader.readAsText(res.data, "utf-8"); //读取文件,结果用字符串形式表示
              reader.onload = async function() {
                //读取完成后,**获取reader.result**
                const data = JSON.parse(reader.result);
                console.log('data',data);
                if (data.success) {
                    that.rePagin = false;
                    Object.assign(that.searchValue, { skip: 0, count: 10 });
                    await that.onReset();
                    that.rePagin = true;
                    that.$message({ message: '导入成功！', type: 'success' });
                    that.uploadValue = [];
                    loading.close();
                } else {
                    that.$alert(`${data.errorMessage}`, { type: 'warning' });
                    that.uploadValue = [];
                    loading.close();
                }
              };
            }})
        }catch{
            this.$message({ message: '导入失败！', type: 'warning' });
            console.log('777');
            loading.close();
            this.uploadValue = [];
        }
        
    }
    closeUpload(){
        this.uploadShow = false;
    }
    importFun(){
      this.uploadShow = true;
    }
    closePop(){
      this.dialogVisible = false;
    }
    /**查看库存明细 */
    async showStock(row){
      await this.getStockDetail(row);
      this.dialogVisible = true;
    }
    /**获取库存明细 */
    async getStockDetail(row){
      let res= await Public.GetTbGoodsById(row.id);
      this.ggList = res.getGoodsItemsList;
      this.ggTotal = row.totalStock;
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/product/index.vue